import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {ExpAccDetailReportModel} from "./exp-acc-detail-report.model";

@Component({
    selector: "wbo-exp-acc-detail-report",
    templateUrl: "./exp-acc-detail-report.component.html",
    providers: [provideReportModel(ExpAccDetailReportModel)]
})
export class ExpAccDetailReportComponent extends AbstractReportPage {

    constructor(public model: ExpAccDetailReportModel) {
        super();
    }
}
